<div class="content">
  <div class="search">
    <div class="input-wrapper">
      <mat-form-field>
        <mat-label>Vehicle ID</mat-label>
        <input matInput [formControl]="vehicleID" />
        @if (vehicleID.hasError && vehicleID.touched) {
          <mat-error>Vehicle ID required</mat-error>
        }
      </mat-form-field>
    </div>
    <button matButton="filled" class="search-button" (click)="submit()" type="submit" [disabled]="vehicleID.value === '' || isLoading">
      <mat-icon fontIcon="search" color="white"></mat-icon>
      SEARCH
    </button>
  </div>

  @if (errorMessage) {
    <h4 class="service-errors">
      <mat-icon fontIcon="error" color="red"></mat-icon><span>{{ errorMessage }}</span>
    </h4>
  }
  @if (hasData) {
    @if (isLoading) {
      <mat-spinner></mat-spinner>
    } @else {
      <status-bar [status]="status" [tripInfo]="tripInformation" [emvHeartbeats]="emvHeartbeats"> </status-bar>
    }
  }
  <!-- hidden because we still need the component to initialise behind the scenes even if there is no data -->
  <div [hidden]="!hasData || isLoading" class="google-maps-container">
    <google-map class="google-map" [mapModel]="mapModel"> </google-map>
    <div class="gps-legends">
      <h5>Map pins:</h5>
      <div class="legend-group">
        <div class="legend">
          <mat-icon class="bdc-icon" fontIcon="navigation" [style]="{ color: '#41AD49' }"></mat-icon>
          <mat-icon class="bdc-icon" fontIcon="navigation" [style]="{ color: '#E41326' }"></mat-icon>
          <mat-icon class="bdc-icon" fontIcon="navigation" [style]="{ color: '#F77D2B' }"></mat-icon>
          <p>BDC GPS</p>
        </div>
        <div class="legend">
          <mat-icon class="cp-icon" fontIcon="podcasts" [style]="{ color: 'white', 'background-color': '#41AD49' }"></mat-icon>
          <mat-icon class="cp-icon" fontIcon="podcasts" [style]="{ color: 'white', 'background-color': '#E41326' }"></mat-icon>
          <mat-icon class="cp-icon" fontIcon="podcasts" [style]="{ color: 'white', 'background-color': '#F77D2B' }"></mat-icon>
          <mat-icon class="cp-icon" fontIcon="podcasts" [style]="{ color: 'white', 'background-color': '#F2F2F2' }"></mat-icon>
          <mat-icon class="cp-icon" fontIcon="podcasts" [style]="{ color: 'white', 'background-color': '#0076FF' }"></mat-icon>
          <p>Cradlepoint GPS</p>
        </div>
      </div>
    </div>
  </div>
</div>
